import { useId } from "react";

// Icône de marque PROXIreduc-28 : pin de localisation + pourcentage.
// variant: "color" (défaut) ou "white" (fonds sombres).
export const BrandMark = ({ size = 36, className = "", variant = "color", ...props }) => {
  const gid = useId();
  const white = variant === "white";
  const pct = white ? "rgba(15,15,17,0.45)" : "#E05638";
  return (
    <svg
      width={(size * 236) / 260}
      height={size}
      viewBox="0 0 236 260"
      className={className}
      role="img"
      aria-label="PROXIreduc-28"
      {...props}
    >
      <defs>
        <linearGradient id={gid} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#F2762A" />
          <stop offset="1" stopColor="#E05638" />
        </linearGradient>
      </defs>
      <path d="M118,246 C118,246 34,174 34,114 C34,62 72,24 118,24 C164,24 202,62 202,114 C202,174 118,246 118,246 Z"
            fill={white ? "#FFFFFF" : `url(#${gid})`} />
      {!white && <circle cx="118" cy="110" r="52" fill="#FFFFFF" />}
      <line x1="98" y1="137" x2="138" y2="83" stroke={pct} strokeWidth="11" strokeLinecap="round" />
      <circle cx="101" cy="95" r="9" fill={pct} />
      <circle cx="135" cy="125" r="9" fill={pct} />
    </svg>
  );
};

export default BrandMark;
